'use client';
const MANIFEST_STYLES = {
    utility: {
        hashed: 'utility.fd426993c54cb69b6d6d0dfaae7b67fa.min.css',
        versioned: 'utility.min.css'
    },
    core: {
        hashed: 'core.9c632eef4187b8a9b3e8f57e4bb3e7b7.min.css',
        versioned: 'core.min.css'
    },
    zoomControls: {
        hashed: 'zoom-controls.893525e1623bc86bf96a645eded0aef0.min.css',
        versioned: 'zoom-controls.min.css'
    },
    visible: {
        hashed: 'visible.388bb400607befa65ff09c5a81d28b7f.min.css',
        versioned: 'visible.min.css'
    },
    toggleSwitch: {
        hashed: 'toggle-switch.4f663a32000604c198b2fd4b091924f2.min.css',
        versioned: 'toggle-switch.min.css'
    },
    thumbnailsHero: {
        hashed: 'thumbnails-hero.7b3fa59f58da180add3cd7bf3c5913d8.min.css',
        versioned: 'thumbnails-hero.min.css'
    },
    tabs: {
        hashed: 'tabs.ea5cab6d098bad4ba156ee3acd1fee09.min.css',
        versioned: 'tabs.min.css'
    },
    table: {
        hashed: 'table.4e52d9069a843e8ca01301fc7f341565.min.css',
        versioned: 'table.min.css'
    },
    stepIndicator: {
        hashed: 'step-indicator.7475c81fefa8ce680a43d4fad6c5cb22.min.css',
        versioned: 'step-indicator.min.css'
    },
    standardTile: {
        hashed: 'standard-tile.ba88f90b2f9704ba4f2a7b5dd8220600.min.css',
        versioned: 'standard-tile.min.css'
    },
    spinner: {
        hashed: 'spinner.e28c0ae32bd5b461b339d7683cf90c86.min.css',
        versioned: 'spinner.min.css'
    },
    selectionSet: {
        hashed: 'selection-set.2078c054d5fa323dfa7429ae6d16555d.min.css',
        versioned: 'selection-set.min.css'
    },
    ratingsStars: {
        hashed: 'ratings-stars.12638464b8b6dc6fe50e19fb1a8acf1d.min.css',
        versioned: 'ratings-stars.min.css'
    },
    progressiveImage: {
        hashed: 'progressive-image.f0a54c9123842f31dd3ce49ef0961118.min.css',
        versioned: 'progressive-image.min.css'
    },
    progressBar: {
        hashed: 'progress-bar.eb0d081bb31e4ea4ed2c329001dde212.min.css',
        versioned: 'progress-bar.min.css'
    },
    pricing: {
        hashed: 'pricing.d41d8cd98f00b204e9800998ecf8427e.min.css',
        versioned: 'pricing.min.css'
    },
    priceBar: {
        hashed: 'price-bar.7bdc0ce1cbae90e66e78a75d8923bfe3.min.css',
        versioned: 'price-bar.min.css'
    },
    popover: {
        hashed: 'popover.2e09326fd9e6321e992a85736a5363b6.min.css',
        versioned: 'popover.min.css'
    },
    pagination: {
        hashed: 'pagination.c9dce10a83a5ced7ab8c273211478e2d.min.css',
        versioned: 'pagination.min.css'
    },
    modalDialog: {
        hashed: 'modal-dialog.df892413d24d60f8ceb8749ce8c4b7d5.min.css',
        versioned: 'modal-dialog.min.css'
    },
    listbox: {
        hashed: 'listbox.cb602e2faddbe4880e7c4c8c93fdba7d.min.css',
        versioned: 'listbox.min.css'
    },
    icon: {
        hashed: 'icon.d41d8cd98f00b204e9800998ecf8427e.min.css',
        versioned: 'icon.min.css'
    },
    hidden: {
        hashed: 'hidden.90549d732670d4ba02fac0dc001a0bb8.min.css',
        versioned: 'hidden.min.css'
    },
    grid: {
        hashed: 'grid.393ab9dc32ba1b6be15bf4d30fc3c6d6.min.css',
        versioned: 'grid.min.css'
    },
    fieldSet: {
        hashed: 'field-set.d41d8cd98f00b204e9800998ecf8427e.min.css',
        versioned: 'field-set.min.css'
    },
    carousel: {
        hashed: 'carousel.e818035a87b4e49341dd38a3bc4ac11b.min.css',
        versioned: 'carousel.min.css'
    },
    button: {
        hashed: 'button.d41d8cd98f00b204e9800998ecf8427e.min.css',
        versioned: 'button.min.css'
    },
    banner: {
        hashed: 'banner.e9e505f40210beb13b3941a83a0e871d.min.css',
        versioned: 'banner.min.css'
    },
    avatar: {
        hashed: 'avatar.1f9246f389d891f03fe55ac84d65854a.min.css',
        versioned: 'avatar.min.css'
    },
    anchorBar: {
        hashed: 'anchor-bar.00a3273f7217a62d93a34326a46dbb05.min.css',
        versioned: 'anchor-bar.min.css'
    },
    alertBox: {
        hashed: 'alert-box.f30285f459395d1584c569d9ce09fd35.min.css',
        versioned: 'alert-box.min.css'
    },
    accordion: {
        hashed: 'accordion.779003813eaf424e3734ce21c01cbb18.min.css',
        versioned: 'accordion.min.css'
    }
};

export { MANIFEST_STYLES };
